import React from 'react';
 

const Linkedin  = () => {
  return (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_31_3326)">
<g clipPath="url(#clip1_31_3326)">
<g clipPath="url(#clip2_31_3326)">
<path d="M0 1.43266C0 0.641875 0.662032 0 1.47812 0H18.5218C19.3382 0 20 0.641875 20 1.43266V18.5676C20 19.3586 19.3382 20 18.5218 20H1.47812C0.662109 20 0 19.3587 0 18.5678V1.43266Z" fill="#2668B2"/>
<path d="M6.07773 16.7371V7.73304H3.08492V16.7371H6.07773ZM4.58195 6.5039C5.62539 6.5039 6.275 5.8125 6.275 4.94844C6.25548 4.06469 5.62539 3.39258 4.6018 3.39258C3.5775 3.39258 2.90851 4.06469 2.90851 4.94836C2.90851 5.81242 3.55789 6.50383 4.56234 6.50383L4.58195 6.5039ZM7.7343 16.7371H10.7269V11.7093C10.7269 11.4406 10.7464 11.1712 10.8255 10.9793C11.0417 10.4413 11.5342 9.8845 12.3611 9.8845C13.4437 9.8845 13.8771 10.7102 13.8771 11.9207V16.7371H16.8696V11.5744C16.8696 8.80892 15.3934 7.52195 13.4244 7.52195C11.8101 7.52195 11.1011 8.42425 10.7072 9.03875H10.7271V7.73336H7.73446C7.77352 8.57809 7.7343 16.7371 7.7343 16.7371Z" fill="white"/>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_31_3326">
<rect width="20" height="20" fill="white"/>
</clipPath>
<clipPath id="clip1_31_3326">
<rect width="20" height="20" fill="white"/>
</clipPath>
<clipPath id="clip2_31_3326">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>

  );
};



export default Linkedin;
